function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import utils from '../utils';
var DanmakuListItem = function () {
    function DanmakuListItem(player, danmaku, index) {
        _classCallCheck(this, DanmakuListItem);
        this.player = player;
        this.danmaku = danmaku;
        this.index = index;
        this.el;
        this.col_time;
        this.col_text;
        this.col_date;
        this.list_operations;
        this.button_like;
        this.button_report;
        this.button_delete;
        this.init();
    }
    _createClass(DanmakuListItem, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                var danmaku = this.danmaku;
                this.el = document.createElement('div');
                this.el.className = 'list-row';
                this.el.setAttribute('data-index', this.index);
                this.el.setAttribute('data-mode', this.danmaku.mode);
                this.el.title = ''.concat(danmaku.text, '\n').concat(danmaku.date ? utils.formatterDate(new Date(danmaku.date * 1000), 'YYYY-MM-DD HH:mm:ss') : '-', ' @ ').concat(utils.secondToTime(danmaku.time, false));
                this.el.ondblclick = function (e) {
                    e.target.classList.contains('list-action') || _this.seek();
                };
                this.col_time = document.createElement('span');
                this.col_time.classList.add('list-cell', 'col-time');
                this.col_time.innerText = utils.secondToTime(danmaku.time, false);
                this.el.appendChild(this.col_time);
                this.col_text = document.createElement('span');
                this.col_text.classList.add('list-cell', 'col-text');
                this.col_text.innerText = danmaku.text;
                this.el.appendChild(this.col_text);
                this.col_date = document.createElement('span');
                this.col_date.classList.add('list-cell', 'col-date');
                this.col_date.innerText = danmaku.date ? utils.formatterDate(new Date(danmaku.date * 1000), 'YY-MM-DD HH:mm') : '-';
                this.el.appendChild(this.col_date);
                this.list_operations = document.createElement('div');
                this.list_operations.className = 'list-operations';
                this.el.appendChild(this.list_operations);
                this.action_like = document.createElement('span');
                this.action_like.classList.add('list-action', 'action-like');
                this.action_like.innerText = '[点赞]';
                this.action_like.onclick = function () {
                    _this.like();
                };
                this.list_operations.appendChild(this.action_like);
                this.action_report = document.createElement('span');
                this.action_report.classList.add('list-action', 'action-report');
                this.action_report.innerText = '[举报]';
                this.action_report.onclick = function () {
                    _this.report();
                };
                this.list_operations.appendChild(this.action_report);
            }
        },
        {
            key: 'like',
            value: function like() {
                console.log('点赞弹幕 id-'.concat(this.danmaku.id, ' 内容: ').concat(this.danmaku.text));
            }
        },
        {
            key: 'report',
            value: function report() {
                console.log('举报弹幕 id-'.concat(this.danmaku.id, ' 内容: ').concat(this.danmaku.text));
            }
        },
        {
            key: 'seek',
            value: function seek() {
                this.player.seek(this.danmaku.time);
                this.player.play();
            }
        }
    ]);
    return DanmakuListItem;
}();
export default DanmakuListItem;